import { SET_CATEGORY_TO_EDIT } from '../constants';

const initialState = {
	allCategories: [],
	categoryToEdit: false
};

export function categories(state = initialState, action) {
	const categoryState = { ...state }
	switch (action.type) {
		case SET_CATEGORY_TO_EDIT:
			categoryState.allCategories = action.category
			return categoryState

		default:
			return state
	}
}
